module.exports = __webpack_public_path__ + "static/media/Pedidos3.4f0b3603.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancPedidos/Pedidos3.png
// module id = 1782
// module chunks = 0